<template>
  <div class="singleChoice">
    <div class="top">
      题目：
      <el-input
        v-model="smallTopic.topicName"
        placeholder="请输入题目"
        style="width: 70%"
      ></el-input>
    </div>

    <!-- 选项 -->
    <div class="flex">
      <div>
        <span> 选项：</span>
        <span style="margin-left: 110px"> 答案：</span>
      </div>
      <div
        v-for="(item, i) in smallTopic.topicOptions"
        :key="i"
        style="margin: 10px 0"
      >
        <el-input
          v-model="smallTopic.topicOptions[i].options"
          placeholder="请输入选项内容"
          style="width: 30%"
        ></el-input>

        <el-radio
          style="margin-left: 10px"
          v-model="smallTopic.answer"
          :label="i"
        >
          {{ '' }}</el-radio
        >
        <!-- 排序字段 -->
      </div>
    </div>

    <!-- 加号 -->
    <div class="plus-box">
      <el-button icon="el-icon-plus" circle @click="addRow"></el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'singleChoice',
  components: {},
  props: {
    smallTopic: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number
    },
    i: {
      type: Number
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    addRow() {
      this.$emit('addOptins', this.index, this.i);
    }
  }
};
</script>
<style lang="scss" scoped>
.singleChoice {
  // display: flex;
  // align-items: center;
  // margin: 10px;
  .top {
    margin: 10px 0;
  }
  .flex {
    // display: flex;
  }
}
::v-deep .el-radio__label {
  display: none;
}
</style>